import React, { useCallback, useContext } from 'react';

import { TrainingMainGroupContext } from '../../training-main-group.context';
import TrainingMainGroupForm from '../TrainingMainGroupForm';

export default function EditDialog() {
  const { editDialogOpened, setEditDialogOpened, selectedData, reload } = useContext(TrainingMainGroupContext);
  const closeDialog = useCallback(
    (success: boolean) => {
      if (success) {
        reload();
      }
      setEditDialogOpened(false);
    },
    [reload, setEditDialogOpened]
  );

  return <TrainingMainGroupForm open={editDialogOpened} onClose={closeDialog} data={selectedData} />;
}
